import React from 'react';
import { /*FaGithub,*/ FaLinkedin, FaEnvelope } from 'react-icons/fa';
import './SocialIcons.css';

function SocialIcons() {
    return (
        <div className="social-icons">
            <a href="https://linkedin.com/in/lukasschulte" target="_blank" rel="noopener noreferrer" className="social-icon">
                <FaLinkedin />
            </a>
            <a href="mailto:contact@lukasschulte.com" className="social-icon">
                <FaEnvelope />
            </a>
        </div>
    );
}

export default SocialIcons;